import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { H3, Btn } from '../../../AbstractElements';
import Wysiwyg from '../../../Components/Forms/EditorText';
import { postForm } from '../../../hook/request';
import ProgettoAppuntiList from './ProgettoAppuntiList';

export default function ProgettoAppuntiEditor() {
  const { id: progettoId } = useParams<{ id: string }>();

  const [titolo, setTitolo] = useState<string>('');
  const [html, setHtml] = useState<string>('');
  const [saving, setSaving] = useState(false);
  const [listVersion, setListVersion] = useState(0);
  const [file, setFile] = useState<File | null>(null);
  const [fileInputKey, setFileInputKey] = useState(0);
  const [condiviso, setCondiviso] = useState(false);

  if (!progettoId) {
    return <div>Nessun progetto selezionato.</div>;
  }

  const handleSave = async () => {
    try {
      setSaving(true);
      const formData = new FormData();
      formData.append('titolo', titolo);
      formData.append('appunti', html);
      formData.append('condiviso', condiviso ? '1' : '0');

      if (file) {
        formData.append('file', file);
      }

      await postForm(`/progetti/appunti?ID=${encodeURIComponent(progettoId)}`, formData);
      toast.success('Appunti salvati!');
      setTitolo('');
      setHtml('');
      setCondiviso(false);
      setFile(null);
      setFileInputKey(prev => prev + 1);
      setListVersion(prev => prev + 1);
    } catch (err: any) {
      const msg = err?.response?.data?.message ?? err?.message ?? 'Errore di rete';
      toast.error(`Errore salvataggio appunti: ${msg}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <H3 className="mb-0">Appunti progetto</H3>
        <Btn
          type="button"
          color="primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Salvo...' : 'Salva'}
        </Btn>
      </div>

      <div className="card-body">
        <div className="mb-3">
          <label className="form-label">Titolo</label>
          <input
            type="text"
            className="form-control"
            value={titolo}
            disabled={saving}
            onChange={e => setTitolo(e.target.value)}
            placeholder="Inserisci un titolo..."
          />
        </div>

        <Wysiwyg
          value={html}
          onChange={setHtml}
          height={260}
          disabled={saving}
        />

        <div className="mb-3">
          <label className="form-label">Allegato</label>
          <input
            key={fileInputKey}
            type="file"
            className="form-control"
            disabled={saving}
            onChange={e => setFile(e.target.files?.[0] || null)}
          />
        </div>

        <div className="form-check mb-3">
          <input
            id="appunto-condiviso"
            type="checkbox"
            className="form-check-input"
            checked={condiviso}
            disabled={saving}
            onChange={e => setCondiviso(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="appunto-condiviso">
            Condividi appunto con gli altri
          </label>
        </div>

        <ProgettoAppuntiList refreshKey={listVersion} />
      </div>
    </div>
  );
}
